import axios from "axios";

export default function EmployeedocumentAddService(employeeId, files) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/employee/" + employeeId + "/add-document",
    data: {"files": files},
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
